/** One-time activation fees (GHS) by subscription plan tier for per_booking businesses. */

export const ACTIVATION_FEE_GHS_BY_PLAN: Record<string, number> = {
  starter: 249,
  professional: 349,
};

const DEFAULT_ACTIVATION_PLAN_ID = "starter";

export function normalizeActivationPlanId(planId: string | null | undefined): string {
  const id = String(planId || DEFAULT_ACTIVATION_PLAN_ID).trim().toLowerCase();
  if (id === "pro") return "professional";
  if (ACTIVATION_FEE_GHS_BY_PLAN[id] != null) return id;
  return DEFAULT_ACTIVATION_PLAN_ID;
}

export function getActivationFeeGhs(planId: string | null | undefined): number {
  const normalized = normalizeActivationPlanId(planId);
  const fromMap = ACTIVATION_FEE_GHS_BY_PLAN[normalized];
  if (fromMap != null) return fromMap;
  return ACTIVATION_FEE_GHS_BY_PLAN[DEFAULT_ACTIVATION_PLAN_ID];
}

export function formatSignupFeeGhs(amount: number): string {
  return `₵${Number(amount).toFixed(2)}`;
}

export function formatActivationFeeForPlan(planId: string | null | undefined): string {
  return formatSignupFeeGhs(getActivationFeeGhs(planId));
}

/** @deprecated Use getActivationFeeGhs(planId) */
export const BUUKD_SIGNUP_FEE_GHS = ACTIVATION_FEE_GHS_BY_PLAN.starter;
